import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { ManualMessageViewedEvent } from '@post-office/placement-contexts/message-viewed-component';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/townsquare-screen-space-flags';

import { type MessageTemplateContext } from '../../..';

import SpotlightTour from '../../../components/SpotlightTour';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const render: {
	type: 'render';
	validate: (input: unknown) => RenderProps;
	Component: (
		input: PlacementRenderProps & {
			testProp: string;
		},
	) => JSX.Element | null;
} = PlacementFrontend.createFrontendStage({
	type: 'render',
	validate: noValidation<RenderProps>(),
	Component: ({
		userName,
		openRovoPanel,
		toggleSidebar,
		toggleSwitcher,
		isRovoChatOpen,
		dismiss,
	}) => {
		// TODO remove these when props are made non-conditional
		const noop = () => {};

		// TODO: add these back once modal can trigger spotlight tour
		// const { isActive: isTriggerActive } = useTrigger('activate-twc-spotlight');

		// if (!isTriggerActive) {
		// 	return null;
		// }

		return (
			<ManualMessageViewedEvent>
				<SpotlightTour
					userName={userName}
					openRovoPanel={openRovoPanel}
					isRovoChatOpen={isRovoChatOpen ?? false}
					toggleSidebar={toggleSidebar ?? noop}
					isSideNavCollapsed={() => false}
					toggleSwitcher={toggleSwitcher ?? noop}
					dismiss={dismiss}
					sidebarForcedOpen={false}
				/>
			</ManualMessageViewedEvent>
		);
	},
});

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render,
});
